import type { VersionAdoption as VersionAdoptionRow } from '../types'

type Props = {
  rows: VersionAdoptionRow[]
}

export function VersionAdoption({ rows }: Props) {
  return (
    <section className="version-adoption" aria-labelledby="version-adoption-title">
      <header>
        <div>
          <h2 id="version-adoption-title">Active versions</h2>
          <p>Current plugin versions reported by active devices.</p>
        </div>
      </header>
      {rows.length === 0 ? (
        <p className="version-empty">No active-device version data yet.</p>
      ) : (
        <div className="version-grid">
          {rows.slice(0, 12).map((row) => (
            <article key={`${row.product_slug}:${row.plugin_version}`}>
              <div className="version-label">
                <strong>{row.product}</strong>
                <span className="mono">{row.plugin_version}</span>
              </div>
              <div className="version-meter" aria-hidden="true">
                <i style={{ width: `${Math.min(100, Math.max(0, row.percentage))}%` }} />
              </div>
              <div className="version-value">
                <strong>{row.percentage}%</strong>
                <span>{row.active_devices.toLocaleString()} devices</span>
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  )
}
